var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var NOTION_BASE_URL = "https://www.notion.so";

var isPageId = function isPageId(text) {
  var re = new RegExp('^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$');
  return text.length === 36 && re.test(text);
};

var getBlockHashId = function getBlockHashId(blockId) {
  return blockId.split('-').join('');
};

var getFullBlockId = function getFullBlockId(blockId) {
  if (blockId.match("^[a-zA-Z0-9]+$")) {
    return blockId.substr(0, 8) + "-" + blockId.substr(8, 4) + "-" + blockId.substr(12, 4) + "-" + blockId.substr(16, 4) + "-" + blockId.substr(20, 32);
  } else {
    return blockId;
  }
};

var getBrowseableUrl = function getBrowseableUrl(blockID) {
  return "".concat(NOTION_BASE_URL, "/").concat(blockID.split('-').join(''));
};

var getUrlPageId = function getUrlPageId(url) {
  var pUrl;

  if (!process.browser) {
    var parse = require('url').parse;

    pUrl = parse(url);
  } else {
    pUrl = new URL(url);
  }

  var pathList = pUrl.pathname.split('/');
  var pagId = pathList[pathList.length - 1];
  return pagId;
};

var parseImageUrl = function parseImageUrl(url, width) {
  var rUrl;

  if (url.startsWith("https://s3")) {
    var _url$split = url.split("?"),
        _url$split2 = _slicedToArray(_url$split, 1),
        parsedOriginUrl = _url$split2[0];

    rUrl = "".concat(NOTION_BASE_URL, "/image/").concat(encodeURIComponent(parsedOriginUrl).replace("s3.us-west", "s3-us-west"));
  } else if (url.startsWith("/image")) {
    rUrl = "".concat(NOTION_BASE_URL).concat(url);
  } else {
    rUrl = url;
  }

  if (width) {
    return "".concat(rUrl, "?width=").concat(width);
  } else {
    return rUrl;
  }
};

var formatDate = function formatDate(date) {
  return "".concat(date.getFullYear(), "-").concat((date.getMonth() + 1 + "").padStart(2, "0"), "-").concat((date.getDate() + "").padStart(2, "0"));
};

var formatTime = function formatTime(date) {
  return "".concat((date.getHours() + "").padStart(2, "0"), ":").concat((date.getMinutes() + "").padStart(2, "0"));
};

var fixTimeZone = function fixTimeZone(dateAsString, timeZone) {
  var shortTz = new Date().toLocaleString("en", {
    timeZoneName: "short",
    timeZone: timeZone
  }).split(' ').pop();
  return new Date(dateAsString + " " + shortTz);
};

var unFixTimeZone = function unFixTimeZone(date, timeZone) {
  var adjustedTime = date.toLocaleString("en-US", {
    timeZone: timeZone
  });
  return new Date(adjustedTime);
};

module.exports = {
  isPageId: isPageId,
  getBlockHashId: getBlockHashId,
  getFullBlockId: getFullBlockId,
  getBrowseableUrl: getBrowseableUrl,
  getUrlPageId: getUrlPageId,
  parseImageUrl: parseImageUrl,
  formatDate: formatDate,
  formatTime: formatTime,
  fixTimeZone: fixTimeZone,
  unFixTimeZone: unFixTimeZone
};